/**
 * Google OAuth sign-in button. Just anchors to the backend's
 * /api/auth/google/login route, which handles the whole authorization-code
 * dance and drops us back on / with a session cookie set.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleLoginButton({ label = "Continue with Google", testid = "google-login-btn" }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const href = `${backendUrl}/api/auth/google/login`;

  return (
    <a
      href={href}
      data-testid={testid}
      className="w-full inline-flex items-center justify-center gap-3 rounded-full border border-white/10 bg-white text-[#1f1f28] font-medium py-2.5 px-4 hover:bg-white/90 transition shadow-sm"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.7 4.7-6.2 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.6 6.1 29 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.6 6.1 29 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5 0 9.5-1.9 12.9-5l-6-4.9C29 35.7 26.7 36.5 24 36.5c-5.1 0-9.5-3.3-11.2-7.9l-6.6 5.1C9.5 39.7 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.4 4.3-4.4 5.6l6 4.9C40.9 34.8 44 29.9 44 24c0-1.3-.1-2.4-.4-3.5z"/>
      </svg>
      <span>{label}</span>
    </a>
  );
}
